import { render } from "./KubernetesBackupRestore.vue?vue&type=template&id=0f94eb8a"
import script from "./KubernetesBackupRestore.vue?vue&type=script&lang=js"
export * from "./KubernetesBackupRestore.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__